import { useEffect, useState } from 'react';
import { getInmuebles } from '../utils/inmuebles.service';

// Hook personalizado
export function useInmuebles() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    // función async interna (no se puede usar async directo en useEffect)
    const fetch = async () => {
      try {
        const res = await getInmuebles();

        // validamos que sea array (defensivo)
        setData(Array.isArray(res) ? res : []);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { data, loading, error };
}